import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { IAgent, IAgentForm, IAgentUpdatePayload } from '../agenti-proiecte.interface';
import { AgentiProiecteService } from '../agenti-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { finalize } from 'rxjs';
import { phoneValidator } from 'src/app/validators';

@Component({
    selector: 'app-edit-agenti-proiecte',
    templateUrl: './edit-agenti-proiecte.component.html',
    styleUrls: ['./edit-agenti-proiecte.component.scss']
})
export class EditAgentiProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        telefon: new FormControl(this.data.telefon, [Validators.required, phoneValidator()]),
        observatii: new FormControl(this.data.observatii, []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IAgent,
        private dialogRef: MatDialogRef<EditAgentiProiecteComponent>,
        private agentiProiecteService: AgentiProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const {
            name,
            telefon,
            observatii,
        } = this.form.value as IAgentForm;
        const payload: IAgentUpdatePayload = {
            id_agent: this.data.id,
            name,
            telefon,
            observatii,
        };

        this.agentiProiecteService
            .updateAgent(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
